export default "__VITE_ASSET__4LoI7DTU__"